// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiListInferencer } from "@refinedev/inferencer/mui";

// export const CasseList: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiListInferencer
//       fieldTransformer={(field: any) => {
//         // if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//         //   return false;
//         // }

//         return field;
//       }}
//     />
//   );
// };

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useMany } from "@refinedev/core";
import {
  DateField,
  EditButton,
  List,
  ShowButton,
  useDataGrid,
} from "@refinedev/mui";
import React from "react";
export const CasseList = () => {
  const { dataGridProps } = useDataGrid();

  console.log({ dataGridProps: dataGridProps });

  const { data: containerData, isLoading: containerIsLoading } = useMany({
    resource: "containers",
    ids: dataGridProps?.rows?.map((item: any) => item?.container) ?? [],
    queryOptions: {
      enabled: !!dataGridProps?.rows,
    },
  });

  const columns = React.useMemo<GridColDef<any>[]>(
    () => [
      {
        field: "quantity",
        headerName: "Quantity",
        type: "number",
        minWidth: 200,
      },
      {
        field: "createdAt",
        headerName: "Created At",
        minWidth: 250,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "container",
        headerName: "Container",
        minWidth: 300,
        renderCell: function render({ value }) {
          console.log({ value: value?.id });
          return containerIsLoading ? (
            <>Loading...</>
          ) : (
            containerData?.data?.find((item) => item.id === value?.id)?.name ??
              "Container unknowed"
          );
        },
      },
      {
        field: "user",
        headerName: "User",
        valueGetter: ({ row }) => {
          const value = row?.user?.username;

          return value;
        },
        minWidth: 200,
      },
      {
        field: "actions",
        headerName: "Actions",
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    [containerData?.data]
  );

  return (
    <List>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
